<template>
    <div id="editCompany" class="content">
            <h4>{{ title }}</h4>
            <hr>
            <div class="row">
                <div class="col-sm-11">
                    <form class="form" @submit.prevent="updateCompany">
                        <div class="form-group row">
                            <div class="col-sm-2" >
                                <label class="control-label" for="url_short_name">{{ label.company_id }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" disabled id="url_short_name" name="url_short_name" v-model="company.url_short_name" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="display_name">{{ label.company_name }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" required id="display_name" name="display_name" v-model="company.display_name" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="created_at">{{ label.created_at }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" required id="created_at" name="new_created_at" v-model="company.created_at" >
                            </div>
                            <div class="col-sm-2">
                                <label class="control-label" for="ended_at">{{ label.ended_at }}</label>
                            </div>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" required id="ended_at" name="ended_at" v-model="company.ended_at" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="is_reason">{{ label.is_reason }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_reason_options" id="reason_yes" value="1" v-model="company.is_reason">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.reason_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_reason_options" id="reason_no" value="0" v-model="company.is_reason">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.reason_no }}</label>
                                </div>
                            </div>
                            <!--div class="col-sm-2">
                                <label class="control-label" for="is_location">{{ label.is_location }}</label>
                            </!--div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_location_options" id="location_yes" value="1" v-model="company.is_location">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.location_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_location_options" id="location_no" value="0" v-model="company.is_location">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.location_no }}</label>
                                </div>
                            </div -->
                            <div class="col-sm-2">
                                <label class="control-label" for="is_enabled">{{ label.is_enabled }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_enabled_options" id="enabled_yes" value="0" v-model="company.is_enabled">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.enabled_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_enabled_options" id="enabled_no" value="1" v-model="company.is_enabled">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.enabled_no }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="is_photo_clockin">{{ label.is_photo_clockin }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_photo_options_clockin" id="is_photo_clockin_yes" value="1" v-model="company.is_photo_clockin">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.is_photo_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_photo_options_clockin" id="is_photo_clockin_no" value="0" v-model="company.is_photo_clockin">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.is_photo_no }}</label>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <label class="control-label" for="is_photo_clockout">{{ label.is_photo_clockout }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_photo_options_clockout" id="is_photo_clockout_yes" value="1" v-model="company.is_photo_clockout">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.is_photo_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="is_photo_options_clockout" id="is_photo_clockout_no" value="0" v-model="company.is_photo_clockout">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.is_photo_no }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="can_geolocation">{{ label.can_geolocation }}</label>
                            </div>
                            <div class="col-sm-1">
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="can_geolocation_options" id="can_geolocation_yes" value="1" v-model="company.can_geolocation">
                                    <label class="form-check-label" for="inlineRadio1">{{ label.can_geolocation_yes }}</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="can_geolocation_options" id="can_geolocation_no" value="0" v-model="company.can_geolocation">
                                    <label class="form-check-label" for="inlineRadio2">{{ label.can_geolocation_no }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="remark">{{ label.URL }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="URL" name="URL" v-model="company.URL" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-2">
                                <label class="control-label" for="remark">{{ label.remark }}</label>
                            </div>
                            <div class="col-sm-8">
                                <input type="text" class="form-control" id="remark" name="remark" v-model="company.remark" >
                            </div>
                        </div>
                        <div class="form-group row">
                            <!--COMPANY_PROJECT-->
                            <div class="col-sm-offset-1 col-sm-10">

                                <v-dialog v-model="dialogNew" max-width="800px">
                                    <v-btn slot="activator" @click="openNewProjectForm">{{ projectBtnLbl }}</v-btn>
                                    <v-card>
                                        <v-card-title><h5>{{ newProjectFormTitle }} {{ company.display_name }}</h5></v-card-title>
                                        <v-card-text>
                                            
                                            <div class="form-group row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.project_name }}</label>
                                                </div>
                                                <div class="col-sm-8">
                                                    <select class="form-control" v-model="project.project_id">
                                                        <option v-for="(project, index) in projects" :key="index" v-bind:value="project.id">{{ project.display_name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.created_at }}</label>
                                                </div>
                                                <div class="col-sm-3">
                                                    <input type="date" class="form-control" v-model="project.created_at" >
                                                </div>
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.ended_at }}</label>
                                                </div>
                                                <div class="col-sm-3">
                                                    <input type="date" class="form-control" v-model="project.ended_at" >
                                                </div>
                                            </div>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-btn @click="saveProject()">SAVE</v-btn>
                                            <v-btn @click="dialogNew = false">CANCEL</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>


                                <v-dialog v-model="dialogEdit" max-width="800px">
                                    <v-card>
                                        <v-card-title><h5>{{ editProjectFormTitle }} {{ company.display_name }}</h5></v-card-title>
                                        <v-card-text>

                                            <div class="form-group row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.project_name }}</label>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" class="form-control" v-model="project.display_name" disabled>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.created_at }}</label>
                                                </div>
                                                <div class="col-sm-3">
                                                    <input type="date" class="form-control" v-model="project.created_at" >
                                                </div>
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.ended_at }}</label>
                                                </div>
                                                <div class="col-sm-3">
                                                    <input type="date" class="form-control" v-model="project.ended_at" >
                                                </div>
                                            </div>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-btn @click="updateProject(project.id)">SAVE</v-btn>
                                            <v-btn @click="dialogEdit = false">CANCEL</v-btn>
                                        </v-card-actions>

                                    </v-card>
                                </v-dialog>
                                <br />
                                <br />
                            </div>
                            
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <v-data-table
                                        :headers="headers"
                                        :items="companyProjects"
                                        v-bind:pagination.sync="pagination"
                                        class="elevation-1 fxed-header"
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.index + 1 }}</td>
                                            <td class="text-xs-left">{{ props.item.url_short_name }}</td>
                                            <td class="text-xs-left">{{ props.item.display_name }}</td>
                                            <td class="text-xs-left">
                                                {{ props.item.created_at | formatDate }}
                                            </td>
                                            <td class="text-xs-left">
                                                {{ props.item.ended_at | formatDate }}
                                            </td>
                                            <td class="justify-center layout px-0">
                                                <v-icon
                                                    small
                                                    class="mr-2 pt-3"
                                                   @click="openEditProjectForm(props.item)"
                                                >
                                                    edit
                                                </v-icon>
                                                <v-icon
                                                    small
                                                    class="pt-3"
                                                    @click="deleteProject(props.item, props.item.id, props.item.display_name)"
                                                >
                                                    delete
                                                </v-icon>
                                            </td>
                                        </template>
                                        <template slot="pageText" slot-scope="props">
                                            Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </div>
                            </div>
                        </div>

                        <div class="form-group row">
                            <!--COMPANY_GEO LOCATION-->
                            <div class="col-sm-offset-1 col-sm-10">

                                <v-dialog v-model="dialogNewGeo" max-width="800px">
                                    <v-btn slot="activator" @click="openNewGeoForm">{{ geoBtnLbl }}</v-btn>
                                    <v-card>
                                        <v-card-title><h5>{{ newGeoFormTitle }} {{ company.display_name }}</h5></v-card-title>
                                        <v-card-text>
                                            
                                            <div class="form-group row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.location_name }}</label>
                                                </div>
                                                <div class="col-sm-8">
                                                    <select class="form-control" v-model="geo.location_code">
                                                        <option v-for="(geo, index) in geolocations" :key="index" v-bind:value="geo.location_code">{{ geo.location_name }}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.created_at }}</label>
                                                </div>
                                                <div class="col-sm-3">
                                                    <input type="date" class="form-control" v-model="geo.created_at" >
                                                </div>
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.ended_at }}</label>
                                                </div>
                                                <div class="col-sm-3">
                                                    <input type="date" class="form-control" v-model="geo.ended_at" >
                                                </div>
                                            </div>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-btn @click="saveGeo()">SAVE</v-btn>
                                            <v-btn @click="dialogNewGeo = false">CANCEL</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>


                             <!-- Dialog for Editing an Existing Geolocation -->
                                <v-dialog v-model="dialogEditGeo" max-width="800px">
                                    <v-card>
                                        <v-card-title><h5>{{ editGeoFormTitle }} {{ company.display_name }}</h5></v-card-title>
                                        <v-card-text>

                                            <div class="form-group row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.location_name }}</label>
                                                </div>
                                                <div class="col-sm-8">
                                                    <input type="text" class="form-control" v-model="geo.location_name" disabled>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.created_at }}</label>
                                                </div>
                                                <div class="col-sm-3">
                                                    <input type="date" class="form-control" v-model="geo.created_at" >
                                                </div>
                                                <div class="col-sm-2">
                                                    <label class="control-label">{{ label.ended_at }}</label>
                                                </div>
                                                <div class="col-sm-3">
                                                    <input type="date" class="form-control" v-model="geo.ended_at" >
                                                </div>
                                            </div>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-btn @click="updateGeo(geo.id)">SAVE</v-btn>
                                            <v-btn @click="dialogEditGeo = false">CANCEL</v-btn>
                                        </v-card-actions>

                                    </v-card>
                                </v-dialog>
                                <br />
                                <br />
                            </div>
                           
                            <div class="form-group row">
                                <div class="col-sm-12">
                                    <v-data-table
                                        :headers="geoHeaders"
                                        :items="companyGeolocations"
                                        v-bind:pagination.sync="pagination"
                                        class="elevation-1 fxed-header"
                                    >
                                        <template slot="items" slot-scope="props">
                                            <td class="text-xs-left">{{ props.index + 1 }}</td>
                                            <td class="text-xs-left">{{ props.item.location_code }}</td>
                                            <td class="text-xs-left">{{ props.item.location_name }}</td>
                                            <td class="text-xs-left">{{ props.item.created_at | formatDate }}</td>
                                            <td class="text-xs-left">{{ props.item.ended_at | formatDate }}</td>
                                            <td class="justify-center layout px-0">
                                                <v-icon
                                                    small
                                                    class="mr-2 pt-3"
                                                    @click="openEditGeoForm(props.item)"
                                                >
                                                    edit
                                                </v-icon>
                                                <v-icon
                                                    small
                                                    class="pt-3"
                                                    @click="deleteGeo(props.item, props.item.id, props.item.location_name)"
                                                >
                                                    delete
                                                </v-icon>
                                            </td>
                                        </template>
                                        <template slot="pageText" slot-scope="props">
                                            Rows Per Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                                        </template>
                                    </v-data-table>
                                </div>
                            </div>
                        
                        </div>

                        <div class="form-group row text-center">
                            <div class="col-sm-11">
                                <button type="submit" class="btn btn-primary" >SAVE</button>
                                <router-link :to="`/${$i18n.locale}/company`"><button class="btn btn-primary">CANCEL</button></router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            title: 'EDIT COMPANY',
            newProjectFormTitle: 'ADD NEW PROJECT FOR ',
            newGeoFormTitle: 'ADD NEW GEOLOCATION FOR ',
            editProjectFormTitle: 'EDIT PROJECT FOR ',
            editGeoFormTitle: 'EDIT GEOLOCATION FOR ',
            projectBtnLbl: 'PROJECT +',
            geoBtnLbl: 'ADD GEOLOCATION +',
            label: {
                company_id: 'COMPANY ID',
                company_name: 'COMPANY NAME',
                created_at: 'EFFECTIVE FROM',
                ended_at: 'EFFECTIVE UNTIL',
                is_reason: 'REQUIRE REASON',
                is_photo_clockin: 'REQUIRE PHOTO CLOCKIN',
                is_photo_clockout: 'REQUIRE PHOTO CLOCKOUT',
                is_location: 'LOCATION TAG',
                is_enabled: 'DISABLED',
                reason_yes: 'YES',
                reason_no: 'NO',
                location_yes: 'YES',
                location_no: 'NO',
                enabled_yes: 'YES',
                enabled_no: 'NO',
                is_photo_yes: 'YES',
                is_photo_no: 'NO',
                URL: 'URL',
                remark: 'REMARK',
                project_name: 'PROJECT NAME',
                location_code: 'LOCATION CODE',
                location_name: 'LOCATION NAME',
                can_geolocation: 'GEOFENCING',
                can_geolocation_yes: 'YES',
                can_geolocation_no: 'NO',
            },
            dialogLabel: {
                project: 'PROJECT',
                effective_at: 'EFFECTIVE FROM',
                effective_till: 'EFFECTIVE UNTIL'
            },
            headers: [
                    { text: 'NO', value: 'index' },
                    { text: 'PROJECT ID', value: 'url_short_name' },
                    { text: 'PROJECT NAME', value: 'display_name' },
                    { text: 'EFFECTIVE FROM', value: 'effective_at' },
                    { text: 'EFFECTIVE UNTIL', value: 'effective_till' },
                    { text: 'ACTION', value: 'action' },
            ],
            geoHeaders: [
                    { text: 'NO', value: 'index' },
                    { text: 'LOCATION CODE', value: 'location_code' },
                    { text: 'LOCATION NAME', value: 'location_name' },
                    { text: 'EFFECTIVE FROM', value: 'created_at' },
                    { text: 'EFFECTIVE UNTIL', value: 'ended_at' },
                    { text: 'ACTION', value: 'action' },
            ],
            newGeoForm: false,
            companyGeolocations: [],
            geolocations: [],
            dialogNewGeo: false,
            dialogEditGeo: false,
            geo: {
                id: '',
                location_code: '',
                location_name: '',
                created_at: '',
                ended_at: '',
            },
            
            id: this.$route.params.id,
            company: {
                url_short_name: null,
                display_name: null,
                created_at: null,
                ended_at: null,
                is_reason: [],
                is_photo_clockin: 0,
                is_photo_clockout: 0,
                is_location: [],
                is_enabled: [],
                can_geolocation: 1,
                remark: null,
                URL: null
            },
            editProject: null,
            companyProjects: [],
            projects: [],
            dialogNew: false,
            dialogEdit: false,
            projectIndex: -1,
            project: {
                id: '',
                company_id: '',
                project_id: '',
                created_at: '',
                ended_at: ''
            },
            validationMsg: '',
            status: '',
            newProjectForm: false,
            pagination: {'sortBy': 'created_at', 'descending': true, 'rowPerPage': -1},
        }
    },

    methods: {
        loadcompany() {
            var vm = this
            var moment = require('moment')

            axios.get(this.$store.getters.rootAPI+ '/company/'+ vm.id)
            .then(function (response) {
                var company = response.data.company
                vm.company.url_short_name = company.url_short_name
                vm.company.display_name = company.display_name
                vm.company.created_at = moment(company.created_at).format('YYYY-MM-DD')
                vm.company.ended_at = moment(company.ended_at).format('YYYY-MM-DD')
                vm.company.is_reason = company.is_reason
                vm.company.is_photo_clockin = company.is_photo_clockin
                vm.company.is_photo_clockout = company.is_photo_clockout
                vm.company.is_location = company.is_location
                vm.company.is_enabled = company.is_enabled
                vm.company.can_geolocation = company.can_geolocation
                vm.company.URL = company.URL
                vm.company.remark = company.remark
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        loadCompanyProjects() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/company/project/'+ vm.id)
            .then(function (response) {
                vm.companyProjects = response.data.rec
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        loadGeolocations() {
            var vm = this;
            axios.get(this.$store.getters.rootAPI + '/company/geolocation/' + vm.id)
            .then(function (response) {
                vm.companyGeolocations = response.data.rec;
            })
            .catch(function (error) {
                vm.status = 'An error occurred.' + error;
            });
        },

        loadAvailableGeolocations() {
            var vm = this;
            axios.get(this.$store.getters.rootAPI + '/geolocation/list')
                .then((response) => {
                    vm.geolocations = response.data.rec.filter(geo => geo.enable === 1);
                })
                .catch((error) => {
                    vm.status = 'An error occurred:' + error;
                });
        },

        openNewProjectForm() {
            this.loadProjects()
            this.newProjectForm = !this.newProjectForm
        },

        openNewGeoForm() {
            this.loadAvailableGeolocations();
            this.newGeoForm = !this.newGeoForm;
        },

        openEditProjectForm(item) {
            var moment = require('moment')
            item.created_at = moment(item.created_at).format('YYYY-MM-DD')
            item.ended_at = moment(item.ended_at).format('YYYY-MM-DD')

            this.projectIndex = this.companyProjects.indexOf(item)
            this.project = Object.assign({}, item)
            this.dialogEdit = true
        },

        loadProjects() {
            var vm = this

            axios.get(this.$store.getters.rootAPI + '/clock/projects')
            .then(function (response) {
                vm.projects = response.data.rec
            })
            .catch(function (error) {
                vm.status = 'An error occured.' + error
            })
        },

        updateProject(id) {
            var vm = this

            axios.put(this.$store.getters.rootAPI + '/company/project/' + id, {
                created_at : vm.project.created_at,
                ended_at : vm.project.ended_at,
                company_id: vm.project.company_id,
                project_id: vm.project.project_id
            })
            .then(function(response) {
                vm.status = response.data.status

                if(vm.status === 'success') {
                    vm.loadCompanyProjects()
                    vm.dialogEdit = false
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        },

        saveProject() {
            var vm = this

            axios.post(this.$store.getters.rootAPI + '/company/project/create', {
                company_id : vm.id,
                project_id : vm.project.project_id,
                created_at : vm.project.created_at,
                ended_at : vm.project.ended_at
            })
            .then(function (response) {
                vm.status = response.data.status

                if(vm.status === 'success') {
                    vm.loadCompanyProjects()
                    //vm.projectForm = !vm.projectForm
                    vm.dialogNew = false
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        },

        saveGeo() {
            var vm = this;
            
            const selectedGeolocation = vm.geolocations.find(geo => geo.location_code === vm.geo.location_code);
            vm.geo.location_name = selectedGeolocation.location_name;

            const isOverlapping = vm.companyGeolocations.some(existingGeo => {
                return existingGeo.location_code === vm.geo.location_code && 
                (
                    (vm.geo.created_at <= existingGeo.ended_at && vm.geo.ended_at >= existingGeo.created_at)
                );
            });

            if (isOverlapping) {
                alert('Validation error: The date range overlaps with an existing entry for this location.');
                return;
            }

            axios.post(this.$store.getters.rootAPI + '/company/geolocation/create', {
                company_id: vm.id,
                location_code: vm.geo.location_code,
                location_name: vm.geo.location_name,
                created_at: vm.geo.created_at,
                ended_at: vm.geo.ended_at,

            })
            .then(function (response) {
                vm.status = response.data.status

                if (vm.status === 'success') {
                    vm.loadGeolocations()
                    vm.dialogNewGeo = false
                } 
                    
                if (response.data.errors && response.data.errors.length > 0) 
                {
                    vm.validationMsg = response.data.errors[0].msg;
                    alert('Validation error: ' + vm.validationMsg);
                }
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        },


        deleteProject(item, id, name) {
            var vm = this
            const index = vm.companyProjects.indexOf(item)

            if(confirm('Are you sure you want to delete ' + name + '?')) {
                axios.delete(this.$store.getters.rootAPI + '/company/project/' + id)
                .then(function (response) {
                        vm.companyProjects.splice(index, 1)
                    })
                .catch(function (error) {
                    alert('An error occured.')
                })
                }
        },


        updateCompany() {
            var vm = this
            let route = '/' + this.$i18n.locale + '/company'

            axios.put(this.$store.getters.rootAPI + '/company/'+ vm.id, {
                display_name: vm.company.display_name,
                created_at: vm.company.created_at,
                ended_at: vm.company.ended_at,
                is_reason: vm.company.is_reason,
                is_photo_clockin: vm.company.is_photo_clockin,
                is_photo_clockout: vm.company.is_photo_clockout,
                is_location: vm.company.is_location,
                is_enabled: vm.company.is_enabled,
                can_geolocation: vm.company.can_geolocation,
                url: vm.company.URL,
                remark: vm.company.remark
            })
            .then(function(response) {
                vm.status = response.data.status

                if(vm.status === 'success') {
                    vm.$router.push(route)
                }

                if(response.data.errors.length > 0)
                {
                    vm.validationMsg = response.data.errors[0].msg
                    alert('Validation error. ' + vm.validationMsg)
                }
            })
            .catch(function (error) {
                if(error.response) {
                    vm.status = error.response.data
                    alert('An error occured. ' + vm.status)
                }
            })
        },

        openEditGeoForm(item) {
            var moment = require('moment');
            item.created_at = moment(item.created_at).format('YYYY-MM-DD');
            item.ended_at = moment(item.ended_at).format('YYYY-MM-DD');

            this.geo = Object.assign({}, item);
            this.dialogEditGeo = true;
        },

        updateGeo(id) {
            var vm = this;

            const isOverlapping = vm.companyGeolocations.some(existingGeo => {
                return existingGeo.location_code === vm.geo.location_code && existingGeo.id !== id && 
                (
                    (vm.geo.created_at <= existingGeo.ended_at && vm.geo.ended_at >= existingGeo.created_at)
                );
            });

            if (isOverlapping) {
                alert('Validation error: The date range overlaps with an existing entry for this location.');
                return;
            }

            axios.put(this.$store.getters.rootAPI + '/company/geolocation/' + id, {
                company_id: vm.id,
                location_code: vm.geo.location_code,
                location_name: vm.geo.location_name,
                created_at: vm.geo.created_at,
                ended_at: vm.geo.ended_at,
            })
            .then(function (response) {
                if (response.data.status === 'success') {
                    vm.loadGeolocations();
                    vm.dialogEditGeo = false;
                }
                if (response.data.errors && response.data.errors.length > 0) {
                    vm.validationMsg = response.data.errors[0].msg;
                    alert('Validation error. ' + vm.validationMsg);
                }
            })
            .catch(function (error) {
                alert('An error occurred.' + error);
            });
        },

        deleteGeo(item, id, name) {
            var vm = this;
            const index = vm.companyGeolocations.indexOf(item);
            if (confirm('Are you sure you want to delete ' + name + '?')) {
                axios.delete(this.$store.getters.rootAPI + '/company/geolocation/' + id)
                .then(function (response) {
                    vm.companyGeolocations.splice(index, 1);
                })
                .catch(function (error) {
                    alert('An error occurred.' + error);
                });
            }
        },

    },
/*
    watch: {
      dialogNew (val) {
        val || this.close()
      },

      dialogEdit (val) {
        val || this.close()
      }
    },
*/
    mounted() {
        this.loadCompanyProjects()
        this.loadGeolocations()
        
    },
    created() {
        document.body.setAttribute('data-app', true)
        this.loadcompany()
        
    
    }
}
</script>

<style lang="stylus">
@import '~vuetify-stylus-fixed-table-header';

.fixed-header {
  fixed-table-header(35vh)
}
</style>



// WEBPACK FOOTER //
// src/components/company/EditCompany.vue